import { createControlFn } from "../create-control-fn"

const controlCityFieldFn = createControlFn({
  filterValueCb: (value) => /^[a-zA-Z\-. ()']*$/.test(value),
})
const controlForeignCityFieldFn = createControlFn({
  filterValueCb: (value) => /^[a-zA-Zàáèéìíòóùú0-9 .'-]*$/.test(value),
})

export { controlCityFieldFn, controlForeignCityFieldFn }
